document.addEventListener("DOMContentLoaded", async () => {
    const addToCart = document.querySelector(".dynamicAbButton");
    // console.log("Mounted R Script");
    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      })

    
  
    const inputs = Array.from(document.querySelectorAll(".product-variant-card__item input"));
    const priceBox = document.querySelector(".gppCustom");
    const varTitle = document.querySelector(".gppVariantTitle");
    const bestTitle = document.querySelector(".gppValueTitle");
  
    function updatePrice(price, compare, currency, savings, variant, best, id) {
      
      let html = `<span class="price">${price}</span>
      `;
      if (compare && compare !== "" && compare !== price) {
        html += `<span class="compare">${compare} ${currency}</span>`;
      }
      if (savings && savings !== "") {
        html += `<span class="gridPriceSavingsCtn">
                            <span class="gridPriceSavings">
                             ${savings}
                            </span>
                        </span>`;
      }
      varTitle.innerHTML = variant;
      bestTitle.innerHTML = best;
      priceBox.innerHTML = html;

      const discountultimate = "?discount=ULTIMATERELIEF"
      const discountdouble = "?discount=DOUBLERELIEF"
      
      if(id == "46833788158170"){
        const base = `${id}:1`
        const greenGift = "45537782857946:1"
        const sprayGift = "45414618792154:1"
        addToCart.href = `https://mymagichealer.com/cart/${base}`
        
      } else if (id == "46833788125402") {
        console.log("GREEN");
        
          const greenGift = "45537782857946:1"
            const base = `${id}:1`            
            addToCart.href = `https://mymagichealer.com/cart/${base}`
        
      } else if(id == "46833788092634") {

        addToCart.href = `https://mymagichealer.com/cart/46833788092634:1`
      }else if(id == "47688259928282") {

        addToCart.href = `https://mymagichealer.com/cart/47688259928282:1`
      } else if(id == "47688259895514") {

        addToCart.href = `https://mymagichealer.com/cart/47688259895514:1`
      } else if(id == "47688259961050") {

        addToCart.href = `https://mymagichealer.com/cart/47688259961050:1`
      }

    }
  
    function syncFromInput(input) {
      const price = input.parentElement.getAttribute('data-variant-price')
      const compare = input.dataset.compare;
      const savings = input.dataset.savings || ""
      const c = input.dataset.currency;
      const variantTitle = input.dataset.variant || ""
      const best = input.dataset.best || ""
      const variantId = input.dataset.vid

      updatePrice(price, compare, c, savings, variantTitle, best, variantId);
    }

    inputs.forEach(input => {
      input.addEventListener("change", () => {
        if (input.checked) {
          syncFromInput(input);
        }
      });
    });

    // Initialize the price box / title / CTA from the pre-selected card on load.
    // The server renders .gppCustom with the first variant, so without this the
    // page shows the wrong price until the user switches a card (see issue: price
    // shows as 48.00 USD until a bundle is toggled).
    const checkedInput = inputs.find(input => input.checked);
    if (checkedInput) {
      syncFromInput(checkedInput);
    }

  });
  